import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { LookupList } from '../../core/models/lookup-list.model';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CardContentComponent } from '../../shared/components/card/card-content.component';
import { CardHeaderComponent } from '../../shared/components/card/card-header.component';
import { CardTitleComponent } from '../../shared/components/card/card-title.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { EntityListSelectorComponent } from '../../shared/components/entity-list-selector/entity-list-selector.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { HasPermissionDirective } from '../../shared/directives/has-permission.directive';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-lookup-lists',
  standalone: true,
  imports: [
    CardComponent,
    CardHeaderComponent,
    CardTitleComponent,
    CardContentComponent,
    IconComponent,
    ButtonComponent,
    HasPermissionDirective,
    TranslatePipe,
    EntityListSelectorComponent,
  ],
  templateUrl: './lookup-lists.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lookup-lists.component.css',
})
export class LookupListsComponent {
  private router = inject(Router);

  createNew(): void {
    this.router.navigate(['/lookup-lists/new']);
  }

  edit(list: LookupList): void {
    this.router.navigate(['/lookup-lists', list.id]);
  }
}
